export function createFnWithUrl<URI extends string, Fn extends (uri: URI, ...args: any[]) => any>(fn: Fn, uri: URI) {
  const newFn = (...args: Parameters<Fn> extends [URI, ...infer P] ? P : any[]) => fn(uri, ...args) as ReturnType<Fn>
  return Object.assign(newFn, { url: uri })
}
